export default {
  name: 'NotFound',
  data() {
    return {
      timeCount: null,
    };
  },
  beforeDestroy() {
    clearTimeout(this.timeCount);
  },
  mounted() {
    this.timeCount = setTimeout(() => {
      this.$router.push('/menu');
    }, 5000);
  },
};
